<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

  <v-row class="promotion-row-list">
    <v-col class="pl-5 list-text-name">
      <!--{{ promotion.nickcode}}-->
      {{ promotion.name }}
    </v-col>
    <v-col class="col-3 text-left stock">

          <span v-if="promotion.promotion_type==='S'" class="float-right">
          {{ promotion.total_price }}<span class="currency">บ.</span>
          </span>
          <span v-else class="float-right">
          -
          </span>

      <span v-if="Promotion.calStock(promotion)!=='n/a'" class="float-right mr-2">
            {{ $helper.number_format(Promotion.calStock(promotion)) }}<span class="unit">ชุด</span>
            /
          </span>
    </v-col>

    <v-col class="col-2 text-right pr-5">
      <v-btn :class="$store.state.carts.current_promotion_map[promotion.id]?'primary':''" :loading="is_loading"
             class="add-button"
             @click.stop="onClickAddCart(promotion)">เพิ่ม
        <span v-if="$store.state.carts.current_promotion_map[promotion.id]">
              {{
            $store.state.carts.current_promotion_map[promotion.id][0].quantity / promotion.product_promotions[0].quantity
          }}</span>
      </v-btn>
    </v-col>
  </v-row>


</template>
<style lang="scss" scoped>
.list-text-name {
  font-size: 18px;
}

.stock {
  font-size: 20px;
}

.unit {
  font-size: 0.7em;
}

.percent {
  font-size: 0.7em;
}

.currency {
  /*display: block;*/
  /*width: 32px;*/
  /*float: right;*/
  font-size: 0.7em;
}

.promotion-row-list {
  font-size: 22px;
  height: 65px;
  align-items: center;
  line-height: 1.2;

  .col {
    padding: 4px;
  }
}

@media (max-height: 700px) {
  .add-button {
    padding: 0 4px !important;
    min-width: 10px !important;
  }
  .promotion-row-list {
    font-size: 18px;
  }
  .stock {
    font-size: 16px;
  }
}


</style>

<script lang="ts">

import {Promotion} from '@/models/Promotion'
import {Component, Prop, Vue} from 'vue-property-decorator'

@Component({
  components: {},
})
export default class PromotionRowGrid extends Vue {
  @Prop() promotion: Promotion
  @Prop() onClickAddCart: Function
  @Prop() is_loading: Boolean

  Promotion = Promotion
}

</script>
